import {AfterViewInit, Directive, ElementRef, Input, ViewChild} from "@angular/core";

@Directive({
    selector: '[data-table-cell] [content]'
})
export class DataTableCellDirective implements AfterViewInit {
    
    @Input('content')
    public Content: string | HTMLElement;
    
    constructor(private _cell: ElementRef) {}
    
    ngAfterViewInit() {
        if (typeof this.Content === 'string') {
            this._cell.nativeElement.innerText = this.Content;
        }
        else {
            this._cell.nativeElement.append(this.Content);
        }
    }
    
    static BooleanFormatter(value: boolean): HTMLDivElement {
        let result = document.createElement('div');
        
        if (value != null) {
            result.className = 'indicator ' + (value ? 'green' : 'red');
        }
        
        return result;
    }
    
    static ColorIndicatorFormatter(color: string, tooltip?: string, value?: string): HTMLDivElement {
        let result = document.createElement('div');
        let indicator = document.createElement('div');
        
        result.className = 'd-flex align-items-center gap-2';
        indicator.className = 'indicator mr-1';
        
        if (color[0] == '#') {
            indicator.style.backgroundColor = color;
        }
        else {
            indicator.className += ' ' + color;
        }
        
        if (tooltip) {
            indicator.title = tooltip;
        }
        
        result.append(indicator);
        
        if (value) {
            result.append(value);
        }
        
        return result;
    }
}